import React, { useContext, useEffect, useState } from 'react';
import ls from 'local-storage';
import {
  CButton,
  CCard,
  CHeader,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
  CCol,
  CCardHeader,
  CCardBody
} from '@coreui/react';
import Moment from 'moment';
import { DateRangePicker } from 'react-date-range';
import { format, isWeekend } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import formatter from 'src/reusables/formatter';
import { useWindowDimensions } from 'src/reusables/useWindowDimension';
import BoothPicker from 'src/components/BoothPicker';
import { getVoucherList, getVoucherSummary } from 'src/services/Voucher/Voucher';
import DownloadExcel from 'src/reusables/DownloadExcel';
import { AuthContext } from 'src/App';
import Authentication, { AUTH_KEY } from 'src/utils/auth/Authentication';
import DataTable from 'src/components/DataTable';

function VoucherList() {
  const [drModal, setDrModal] = useState(false);
  const [refetch, setRefetch] = useState(false);
  const [renderCounter, setRenderCounter] = useState(false);
  const [tableLoading, setTableLoading] = useState(true);

  const endDay = Moment(new Date()).format('YYYY-MM-DD');
  const max = new Date(endDay);
  const startDay = Moment(new Date('Jan 1 2023')).format('YYYY-MM-DD');

  const [voucherRows, setVoucherRows] = useState([]);
  const [voucherColumns, setVoucherColumns] = useState([]);

  const navigate = useNavigate();
  const Auth = useContext(AuthContext);
  const { height, width, comparison } = useWindowDimensions();

  const [dateRange, setDateRange] = useState([
    {
      startDate: new Date(`${Moment(new Date()).startOf('month')}`),
      endDate: new Date()
    }
  ]);

  async function fetchVoucherList(dateFrom, dateTo, id) {
    const res = await getVoucherList(dateFrom, dateTo, id ?? '');

    const rows =
      res.data &&
      res.data.map((item, i) => {
        return {
          id: i,
          code: item.code,
          price: formatter('currency', item?.price ?? 0),
          discount: formatter('currency', item?.discount ?? 0),
          timeout: item.timeout,
          grandTotal: formatter('currency', item?.grand_total ?? 0),
          frameName: item.frameName,
          trxId: item.id,
          trx: `${item.id} - ${item.merchant_name_trx}`,
          voucherId: item?.voucher_id,
          issuerName: item?.issuer_name,
          paidAt: formatter('completeDate', item?.paidAt ?? '0000-00-00 00:00:00'),
          doneAt:
            item?.doneAt !== '0000-00-00 00:00:00'
              ? formatter('completeDate', item?.doneAt ?? '0000-00-00 00:00:00')
              : 'Not Printed Yet',
          type: item?.discount_type === 'percentage' ? `${item?.discount_amount}%` : `Rp ${item?.discount_amount}`,
          merchantName: item?.merchant_id === '0' || item?.merchant_id === 0 ? 'System' : item?.merchant_name
        };
      });

    setVoucherRows(rows);

    const columns = [
      { field: 'code', headerName: 'Voucher Code', width: '150' },
      { field: 'trx', headerName: 'Used In', width: '150' },
      { field: 'issuerName', headerName: 'Issuer', width: '150' },
      { field: 'merchantName', headerName: 'Issuer Merchant', width: '150' },
      { field: 'type', headerName: 'Type', width: '150' },
      { field: 'price', headerName: 'Revenue', width: '150' },
      { field: 'discount', headerName: 'Discount', width: '150' },
      { field: 'grandTotal', headerName: 'Grand Total', width: '150' },
      // {field:'timeout', headerName:'Timeout', width:"150"},
      // {field:'frameName', headerName:'Frame', width:"150"},
      { field: 'paidAt', headerName: 'Paid At', width: '200' }
      // {field:'doneAt', headerName:'Done At', width:"200"},
    ];

    setVoucherColumns(columns);
    setTableLoading(false);
  }

  // function handleRowClick(params) {
  //   navigate('/voucher-usage-details', { state: params.row });
  // }

  function handleRowClick(params) {
    ls.set('stateVoucher', params.row);
    // navigate('/transaction-details', { state: params.row });
    if (ls.get('stateVoucher')) {
      window.open('/voucher-usage-details', '_blank');
    }
  }

  function customDayContent(day) {
    let extraDot = null;
    if (isWeekend(day)) {
      extraDot = (
        <div
          style={{
            height: '5px',
            width: '5px',
            borderRadius: '100%',
            background: 'orange',
            position: 'absolute',
            top: 2,
            right: 2
          }}
        />
      );
    }
  }

  useEffect(() => {
    setTableLoading(true);
    const newStartDay = formatter('SQLDate', dateRange[0].startDate);
    const newEndDay = formatter('SQLDate', dateRange[0].endDate);
    // if((refetch && renderCounter > 0) || renderCounter === 0){
    fetchVoucherList(newStartDay, newEndDay, ls.get('booth')?.id ?? '');
    setRefetch(false);
    // } else {
    // }

    setRenderCounter(renderCounter + 1);
  }, [dateRange, refetch, drModal]);

  function customDayContent(day) {
    let extraDot = null;
    if (isWeekend(day)) {
      extraDot = (
        <div
          style={{
            height: '5px',
            width: '5px',
            borderRadius: '100%',
            background: 'orange',
            position: 'absolute',
            top: 2,
            right: 2
          }}
        />
      );
    }
    return (
      <div>
        <span
          style={{
            fontWeight: '600'
          }}
        >
          {format(day, 'd')}
        </span>
      </div>
    );
  }

  return (
    <div style={{ color: 'black' }}>
      <CRow>
        <CCol>
          <CButton
            className="ml-3 mb-3 btn btn-dark"
            style={{ backgroundColor: '#4E5B97', border: 'none' }}
            hover="true"
            onClick={() => {
              setDrModal(!drModal);
            }}
          >
            <div>
              {Moment(dateRange[0].startDate).format('ll')}
              {' - '}
              {Moment(dateRange[0].endDate).format('ll')}
            </div>
          </CButton>
        </CCol>
        <CCol>
          <BoothPicker />
        </CCol>
      </CRow>

      <CModal
        visible={drModal}
        style={{
          width: comparison < 1 ? '' : 'fit-content',
          overflowX: comparison < 1 ? 'scroll' : 'visible'
        }}
      >
        <CModalHeader
          style={{
            width: comparison < 1 ? `${(85 * 1) / comparison}vw` : ''
          }}
        >
          <CModalTitle>Date Range</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <CCol xs="12" lg="10">
            <DateRangePicker
              onChange={(item) => {
                setDateRange([item.range1]);
                ls.set('dateRange', item.range1);
              }}
              showSelectionPreview={true}
              moveRangeOnFirstSelection={false}
              months={1}
              maxDate={max}
              ranges={dateRange}
              direction="vertical"
              weekStartsOn={1}
              calendarFocus="backwards"
              preventSnapRefocus={true}
              rangeColors={['#4E5B97']}
              dayContentRenderer={customDayContent}
            />
          </CCol>
        </CModalBody>
        <CModalFooter
          style={{
            width: comparison < 1 ? `${(85 * 1) / comparison}vw` : ''
          }}
        >
          <CButton style={{ backgroundColor: '#4E5B97', border: 'none' }} onClick={() => setDrModal(!drModal)}>
            Close
          </CButton>
          <CButton
            style={{ backgroundColor: '#4E5B97', border: 'none' }}
            onClick={() => {
              setRefetch(true);
              setDrModal(false);
            }}
          >
            OK
          </CButton>
        </CModalFooter>
      </CModal>

      {/* <CModal
      {/* <CModal
        visible={drModal}
        style={{
          width: comparison < 1 ? '' : 'fit-content',
          overflowX: comparison < 1 ? 'scroll' : 'visible'
        }}
      >
        <CModalHeader
          style={{
            width: comparison < 1 ? `${(85 * 1) / comparison}vw` : ''
          }}
        >
          <CModalTitle>Date Range</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <CCol xs="12" lg="10">
            <DateRangePicker
              onChange={(item) => {
                setDateRange([item.range1]);
                ls.set('dateRange', item.range1);
              }}
              showSelectionPreview={true}
              moveRangeOnFirstSelection={false}
              months={1}
              maxDate={max}
              ranges={dateRange}
              direction="vertical"
              weekStartsOn={1}
              calendarFocus="backwards"
              preventSnapRefocus={true}
              rangeColors={['#4E5B97']}
              dayContentRenderer={customDayContent}
            />
          </CCol>
        </CModalBody>
        <CModalFooter
          style={{
            width: comparison < 1 ? `${(85 * 1) / comparison}vw` : ''
          }}
        >
          <CButton
            style={{ backgroundColor: '#4E5B97', border: 'none' }}
            onClick={() => {
              setRefetch(true);
              setDrModal(false);
            }}
          >
            OK
          </CButton>
          <CButton
            style={{ backgroundColor: '#4E5B97', border: 'none' }}
            onClick={() => setDrModal(!drModal)}
          >
            Close
          </CButton>
        </CModalFooter>
      </CModal> */}
      <VoucherSummary
        dateFrom={dateRange[0].startDate}
        dateTo={dateRange[0].endDate}
        boothId={ls.get('booth')?.id ?? ''}
      />

      <CHeader style={{ fontSize: '30px', marginTop: '3vh', padding: '1vh 2vw 1vh 2vw' }}>
        <CCol xs="8">Voucher Usage List: </CCol>
        <CCol xs="4" style={{ display: 'flex', justifyContent: 'flex-end' }}>
          {Auth.isAllowed(Auth.role[AUTH_KEY.export_reports]) && (
            <DownloadExcel
              rows={voucherRows}
              columns={voucherColumns}
              dateFrom={formatter('SQLDate', dateRange[0].startDate)}
              dateTo={formatter('SQLDate', dateRange[0].endDate)}
              excelName="Voucher Usage Report"
              config={{ width: '20' }}
            />
          )}
        </CCol>
      </CHeader>
      <CCard style={{ textAlign: 'center' }}>
        <DataTable
          rows={voucherRows}
          columns={voucherColumns}
          onRowClick={handleRowClick}
          loading={tableLoading}
          style={{ textAlign: 'center' }}
        />
        {/* <DataGrid
          rows={voucherRows}
          columns={voucherColumns}
          onRowClick={handleRowClick}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 10 }
            }
          }}
          pageSizeOptions={[5, 10, 20, 25]}
          checkboxSelection
          style={{ textAlign: 'center' }}
          // slotProps={{toolbar: CustomToolbar}}
        /> */}
      </CCard>
    </div>
  );
}

function VoucherSummary({ dateFrom, dateTo, boothId }) {
  const [voucherUsage, setVoucherUsage] = useState(0);
  const [voucherDiscount, setVoucherDiscount] = useState(0);
  const [voucherContribution, setVoucherContribution] = useState(0);

  function fetchSummary(dateFrom, dateTo, boothId) {
    getVoucherSummary(dateFrom, dateTo, boothId).then((response) => {
      setVoucherUsage(response.data.total_usage);
      setVoucherDiscount(response.data.total_discount);
      setVoucherContribution(response.data.contribution);
    });
  }

  useEffect(() => {
    fetchSummary(Moment(dateFrom).format('YYYY-MM-DD'), Moment(dateTo).format('YYYY-MM-DD'), boothId);
  }, [dateFrom, dateTo]);

  return (
    <CCard>
      <CCardHeader>{`Summary`}</CCardHeader>
      <CCardBody>
        <CRow>
          <CCol md={3} xs={12}>
            <h4>{`Total Usage: ${voucherUsage}`}</h4>
          </CCol>
          <CCol md={5} xs={12}>
            <h4>{`Total Discount: ${formatter('currency', -voucherDiscount)}`}</h4>
          </CCol>
          <CCol md={4} xs={12}>
            <h4>{`Contribution: ${voucherContribution}%`}</h4>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  );
}

export default VoucherList;
